'use client';

import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import HeroDetailClient from '../../components/hero-detail-client';
import { normalizeGameConfig } from '../../lib/game-config';
import { useRegisteredGame } from '../use-registered-game';

/**
 * SPA 角色详情：`/:game/t:heroId`，复用 HeroDetailClient。
 */
export default function SpaHeroPage() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const gameParam = String(params.game || '');
  const routeSegment = String(params.route || '');
  const routeId = routeSegment.replace(/^t/i, '');
  const registered = useRegisteredGame(gameParam);

  const flags = useMemo(() => {
    const offset = Number(searchParams.get('offset'));
    return {
      startAtContent: searchParams.get('view') === 'content',
      initialContentSection:
        searchParams.get('section') === 'archive'
          ? ('archive' as const)
          : ('skills' as const),
      initialSectionOffset: Number.isFinite(offset)
        ? Math.max(-128, Math.min(1000000, offset))
        : undefined,
    };
  }, [searchParams]);

  if (!routeId) {
    return (
      <main className="spa-boot" role="alert">
        <h1>角色不存在</h1>
        <p>
          <a href={`/${gameParam}`}>回首页</a>
        </p>
      </main>
    );
  }

  if (registered.status === 'loading') {
    return (
      <main className="spa-boot" aria-busy="true">
        <p className="spa-boot-status" />
      </main>
    );
  }

  if (registered.status === 'error') {
    return (
      <main className="spa-boot" role="alert">
        <h1>加载失败</h1>
        <p>{registered.message}</p>
        <p>
          <a href={`/${gameParam}`}>回首页</a>
        </p>
      </main>
    );
  }

  const game = normalizeGameConfig(registered.game);

  return (
    <HeroDetailClient
      key={game.key}
      game={game}
      routeId={routeId}
      {...flags}
    />
  );
}
